import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'qr-refund-flight',
    templateUrl: './qr-refund-flight.component.html',
    styleUrls: ['./qr-refund-flight.component.scss'],
    standalone: false
})
export class QrRefundFlightComponent implements OnInit {

  constructor(
    private modalService: NgbModal,
    private _router: Router
  ) { }

  ngOnInit() {
  }

  closeModal() {
    this.modalService.dismissAll();
  }

}